<script>
  import { getContext } from 'svelte';
  const state = getContext('state');

  export let playerData = $state.data.playerData;
  export let playerStats = $state.data.playerStats;

  const eloLimit = [800, 950, 1100, 1250, 1400, 1550, 1700, 1850, 2000];

  const getNextEloMinMax = () => {
    const eloMax = eloLimit[Number(playerData.games.csgo.skill_level) - 1] - Number(playerData.games.csgo.faceit_elo) + 1;
    const eloMin = Number(playerData.games.csgo.faceit_elo) - eloLimit[Number(playerData.games.csgo.skill_level) - 2];

    return [eloMin, eloMax];
  };

  const getLevelColor = (level) => {
    if (level === 1) return 'text-white';
    if (level >= 2 && level <= 3) return 'text-green-600';
    if (level >= 4 && level <= 7) return 'text-yellow-300';
    if (level >8 && level <= 9) return 'text-yellow-500';

    return 'text-red-600';
  }

  const getAvgKills = () => {
    let kills = 0;

    for (let i = 0; i < 20; i++) {
      kills += Number($state.data.matchDisplay[i].player.player_stats.Kills)
    }

    return Math.round(kills / 20);
  };

  let eloMinMax = getNextEloMinMax();
  $ : eloMinMax = getNextEloMinMax();
</script>

<div class="flex  items-start  justify-between">
  <div class="flex  flex-initial  flex-col  font-antonio  uppercase  mr-6 {getLevelColor(playerData.games.csgo.skill_level)}">
    <div class="text-sm  text-center">Level</div>
    <div class="text-5xl  text-center">{playerData.games.csgo.skill_level}</div>
  </div>

  <div class="flex-1  mr-6  text-sm  md:text-base">
    {#if playerData.games.csgo && playerStats}
      <table class="w-full">
        <tr>
          <td class="text-gray-400">ELO</td>
          <td class="text-right">{playerData.games.csgo.faceit_elo}</td>
        </tr>
        {#if Number(playerData.games.csgo.skill_level) !== 1}
        <tr>
          <td class="text-gray-400">ELO To Level {Number(playerData.games.csgo.skill_level) - 1}</td>
          <td class="text-right">-{eloMinMax[0]}</td>
        </tr>
        {/if}
        {#if Number(playerData.games.csgo.skill_level) !== 10}
          <tr>
            <td class="text-gray-400">ELO To Level {Number(playerData.games.csgo.skill_level) + 1}</td>
            <td class="text-right">+{eloMinMax[1]}</td>
          </tr>
        {/if}
      </table>
    {/if}
  </div>
  <div class="flex-1  mr-6  text-sm  md:text-base">
    {#if playerData.games.csgo && playerStats}
      <table class="w-full">
        <tr>
          <td class="text-gray-400">Matches</td>
          <td class="text-right">{playerStats.lifetime['Matches']}</td>
        </tr>
        <tr>
          <td class="text-gray-400">Wins (Win Rate)</td>
          <td class="text-right">{playerStats.lifetime['Wins']} ({playerStats.lifetime['Win Rate %']}%)</td>
        </tr>
        <tr>
          <td class="text-gray-400">Longest Win Streak</td>
          <td class="text-right">{playerStats.lifetime['Longest Win Streak']}</td>
        </tr>
      </table>
    {/if}
  </div>
  <div class="flex-1  justify-start  text-sm  md:text-base">
      <table class="w-full">
        <tr>
          <td class="text-gray-400">Avg. Headshot</td>
          <td class="text-right">{playerStats.lifetime['Average Headshots %']}%</td>
        </tr>
        <tr>
          <td class="text-gray-400">Avg. K/D</td>
          <td class="text-right">{playerStats.lifetime['Average K/D Ratio']}</td>
        </tr>
        {#if playerData.games.csgo && playerStats && $state.data.matchDisplay}
          <tr>
            <td class="text-gray-400">20 Game Avg. Kills</td>
            <td class="text-right">{getAvgKills()}</td>
          </tr>
        {/if}
      </table>
  </div>
</div>
